import { useCallback, useState } from "react";

export const usePagination = (initialPageSize = 10, initialPage = 0) => {
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const setPaginationData = useCallback(
    (data) => {
      if (!data) return;

      // Support both the new PaginatedResponse (data.items) and legacy responses
      const resultItems =
        data.items ||
        data.leads ||
        data.tasks ||
        data.invoices ||
        data.attendance ||
        data.materials ||
        data.projects ||
        data.meetings ||
        data.vendors ||
        data.users ||
        data.roles ||
        [];

      setItems(resultItems);
      setTotalPages(data.totalPages || 0);
      setTotalItems(data.totalItems || 0);
      // Only update currentPage if it's explicitly provided and different from current
      if (data.currentPage !== undefined && data.currentPage !== currentPage) {
        setCurrentPage(data.currentPage);
      }
    },
    [currentPage]
  );

  return {
    items,
    setItems,
    currentPage,
    setCurrentPage,
    totalPages,
    totalItems,
    pageSize,
    setPageSize,
    setPaginationData
  };
};
